import { ActionsUnion, createAction } from 'spw-redux/types';
import { REQUEST_STATUS } from 'spw-constants';
import { ReportEntry } from 'spw-redux/modules/reports/types';
import {
  CalculatorType,
  Scenario,
  IWorksheet,
  IWorksheetRow,
  IWorksheetRowValue,
  ICategoryNote,
  ITotalProgram,
  IChildWorksheetSpaceType,
  IWorksheetAPIObject,
  isProgramScenario,
  ManualGrowthEntryUpdate,
  WorkSeatsRoundingSetting,
} from './types';
import ProgramScenarioFactory from '../../../models/ProgramScenarioFactory';
import { PlainWorksheet } from '../../../models/Worksheet';
import { PlainProgramScenario } from '../../../models/Scenario';
import { IDepartment, IFloor } from '../projects/types';

export const SET_SELECTED_YEAR = 'calculators/SET_SELECTED_YEAR';
export const BUILD_NEW_SCENARIO = 'calculators/BUILD_NEW_SCENARIO';
export const BUILD_NEW_SCENARIO_SUCCESS =
  'calculators/BUILD_NEW_SCENARIO_SUCCESS';
export const SET_CALCULATOR_TYPE = 'calculators/SET_CALCULATOR_TYPE';
export const UPDATE_SCENARIO = 'calculators/UPDATE_SCENARIO';
export const SET_SCENARIO_DIALOG_STATUS =
  'calculators/SET_SCENARIO_DIALOG_STATUS';
export const SET_UPDATE_SCENARIO_DIALOG =
  'calculators/SET_RENAME_SCENARIO_DIALOG';
export const SET_WORKSHEET_UPDATE_DIALOG_STATUS =
  'calculators/SET_WORKSHEET_UPDATE_DIALOG_STATUS';
export const SET_WORKSHEET_NOTES_DIALOG_STATUS =
  'calculators/SET_WORKSHEET_NOTES_DIALOG_STATUS';
export const SET_TOTAL_PROGRAM_DIALOG_STATUS =
  'calculators/SET_TOTAL_PROGRAM_DIALOG_STATUS';
export const SAVE_SCENARIO = 'calculators/SAVE_SCENARIO';
export const SAVE_SCENARIO_SUCCESS = 'calculators/SAVE_SCENARIO_SUCCESS';
export const SAVE_SCENARIO_FAILED = 'calculators/SAVE_SCENARIO_FAILED';
export const SET_FACTOR = 'calculators/SET_FACTOR';
export const SET_GROWTH_YEARS = 'calculators/SET_GROWTH_YEARS';

export const SET_HEADCOUNT_SEAT_COUNT_BASE =
  'calculators/SET_HEADCOUNT_SEAT_COUNT_BASE';
export const SET_YEAR_HEADCOUNT = 'calculators/SET_YEAR_HEADCOUNT';
export const SET_HEADCOUNT_SEAT_COUNT_GROWTH_RATE =
  'calculators/SET_HEADCOUNT_SEAT_COUNT_GROWTH_RATE';
export const GET_PROJECT_SCENARIOS = 'calculators/GET_PROJECT_SCENARIOS';
export const GET_SCENARIOS_SUCCESS = 'calculators/GET_SCENARIOS_SUCCESS';
export const GET_SCENARIOS_FAILED = 'calculators/GET_SCENARIOS_FAILED';
export const GET_SCENARIO = 'calculators/GET_SCENARIO';
export const UPDATE_BUILDING_SCENARIOS =
  'calculators/UPDATE_BUILDING_SCENARIOS';
export const SET_LOADING_SCENARIOS = 'calculators/SET_LOADING_SCENARIOS';
export const SET_CURRENT_SCENARIO = 'calculators/SET_CURRENT_SCENARIO';
export const SET_IS_EDITING_SAVED_SCENARIO =
  'calculators/SET_IS_EDITING_SAVED_SCENARIO';
export const SAVE_UPDATING_SCENARIO = 'calculators/SAVE_UPDATING_SCENARIO';
export const SAVE_SCENARIO_WORK_SEATS_ROUNDING_SETTING =
  'calculators/SAVE_SCENARIO_WORK_SEATS_ROUNDING_SETTING';

export const SET_SUBTOTAL_PROGRAM_MULTIPLIER =
  'calculators/SET_SUBTOTAL_PROGRAM_MULTIPLIER';
export const SET_RSF_LOAD_FACTOR = 'calculators/SET_RSF_LOAD_FACTOR';
export const SET_SUBTOTAL_BUILDING_MULTIPLIER =
  'calculators/SET_SUBTOTAL_BUILDING_MULTIPLIER';
export const SET_PLANNING_FACTOR = 'calculators/SET_PLANNING_FACTOR';
export const SET_TOTAL_PROGRAM_AVAILABLE_USF =
  'calculators/SET_TOTAL_PROGRAM_AVAILABLE_USF';
export const SET_SCENARIO_VALUE = 'calculators/SET_SCENARIO_VALUE';
export const SET_CALCULATOR_LOADING = 'calculators/SET_CALCULATOR_LOADING';
export const SAVE_WORKSHEET = 'calculators/SAVE_WORKSHEET';
export const FETCH_CURRENT_WORKSHEET = 'calculators/FETCH_CURRENT_WORKSHEET';
export const FETCH_CURRENT_WORKSHEET_SUCCESS =
  'calculators/FETCH_CURRENT_WORKSHEET_SUCCESS';
export const FETCH_CURRENT_WORKSHEET_FAILED =
  'calculators/FETCH_CURRENT_WORKSHEET_FAILED';
export const POPULATE_CURRENT_WORKSHEET =
  'calculators/POPULATE_CURRENT_WORKSHEET';
export const SET_IS_DELETE_CONFIRMATION_OPEN =
  'calculators/SET_IS_DELETE_CONFIRMATION_OPEN';
export const POST_WORKSHEET_ROW = 'calculators/POST_WORKSHEET_ROW';
export const CREATE_WORKSHEET_NOTE = 'calculators/CREATE_WORKSHEET_NOTE';
export const SET_TEMPORARY_SCENARIO = 'calculators/SET_TEMPORARY_SCENARIO';
export const SET_IS_CALCULATOR_DIRTY = 'calculators/SET_CALCULATOR_DIRTY';
export const SET_IS_UNSAVED_DIALOG_OPEN =
  'calculators/SET_IS_UNSAVED_DIALOG_OPEN';
export const DELETE_SCENARIO = 'calculators/DELETE_SCENARIO';
export const BULK_UPDATE_SCENARIO = 'calculators/BULK_UPDATE_SCENARIO';
export const UPDATE_DEPARTMENT_SCENARIOS =
  'calculators/UPDATE_DEPARTMENT_SCENARIOS';
export const CREATE_TOTAL_PROGRAM = 'calculators/CREATE_TOTAL_PROGRAM';
export const UPDATE_TOTAL_PROGRAM = 'calculators/UPDATE_TOTAL_PROGRAM';
export const CREATE_TOTAL_PROGRAM_SUCCESS =
  'calculators/CREATE_TOTAL_PROGRAM_SUCCESS';
export const CREATE_TOTAL_PROGRAM_NOTE =
  'calculators/CREATE_TOTAL_PROGRAM_NOTE';
export const GET_TOTAL_PROGRAM = 'calculators/GET_TOTAL_PROGRAM';
export const REBUILD_TOTAL_PROGRAM_SCENARIO_VIEW =
  'calculators/REBUILD_TOTAL_PROGRAM_SCENARIO_VIEW';
export const FETCH_TPS_WORKSHEETS = 'calculators/FETCH_TPS_WORKSHEETS';
export const FETCH_TPS_WORKSHEETS_SUCCESS =
  'calculators/FETCH_TPS_WORKSHEETS_SUCCESS';
export const FETCH_PROJECT_WORKSHEETS = 'calculators/FETCH_PROJECT_WORKSHEETS';
export const FETCH_PROJECT_WORKSHEETS_SUCCESS =
  'calculators/FETCH_PROJECT_WORKSHEETS_SUCCESS';
export const FETCH_PROJECT_WORKSHEETS_FAILED =
  'calculators/FETCH_PROJECT_WORKSHEETS_FAILED';
export const TOTAL_PROGRAM_SCENARIOS_FETCH_SUCCESS =
  'calculators/TOTAL_PROGRAM_SCENARIOS_FETCH_SUCCESS';
export const TOTAL_PROGRAM_SCENARIOS_FETCH_FAILED =
  'calculators/TOTAL_PROGRAM_SCENARIOS_FETCH_FAILED';
export const BULK_UPDATE_TOTAL_PROGRAM =
  'calculators/BULK_UPDATE_TOTAL_PROGRAM';
export const UPDATE_CHILD_WORKSHEET_SPACE_TYPE =
  'calculators/UPDATE_CHILD_WORKSHEET_SPACE_TYPE';
export const FETCH_ALL_CHILD_WORKSHEET_SPACES_SUCCESS =
  'calculators/FETCH_ALL_CHILD_WORKSHEET_SPACES_SUCCESS';
export const CREATE_CHILD_WORKSHEET_SPACE_SUCCESS =
  'calculators/CREATE_CHILD_WORKSHEET_SPACE_SUCCESS';
export const FETCH_ALL_CHILD_WORKSHEET_SPACES =
  'calculators/FETCH_ALL_CHILD_WORKSHEET_SPACES';
export const SET_CHILD_WORKSHEET_SPACES_REQUEST_STATUS =
  'calculators/SET_CHILD_WORKSHEET_SPACES_REQUEST_STATUS';
export const UPDATE_LINKED_SCENARIOS = 'calculators/UPDATE_LINKED_SCENARIOS';
export const POPULATE_WORKSHEET_FROM_REQUEST =
  'calculators/POPULATE_WORKSHEET_FROM_REQUEST';
export const IS_SPACE_TYPE_DELETABLE = 'calculators/IS_SPACE_TYPE_DELETABLE;';
export const SET_IS_SPACE_TYPE_DELETABLE =
  'calculators/SET_IS_SPACE_TYPE_DELETABLE';
export const PREPARE_SCENARIO_FOR_UPDATE =
  'calculators/PREPARE_SCENARIO_FOR_UPDATE';
export const EXPORT_REPORT = 'calculators/EXPORT_REPORT';
export const CLONE_SCENARIO = 'calculators/CLONE_SCENARIO';
export const BUILD_TOTAL_PROGRAMS = 'calculators/BUILD_TOTAL_PROGRAMS';
export const SET_SCENARIO_LIST_TYPE = 'calculators/SET_SCENARIO_LIST_TYPE ';

export const buildNewScenario = (
  calculatorType: CalculatorType,
  options?: { shouldMergeWithCurrentScenario: boolean }
) => createAction(BUILD_NEW_SCENARIO, { calculatorType, options });
export const buildNewScenarioSuccess = (
  scenario: Partial<Scenario>,
  keepOldGrowth = false
) => createAction(BUILD_NEW_SCENARIO_SUCCESS, { scenario, keepOldGrowth });

export const setSelectedYear = (selectedYear: number) =>
  createAction(SET_SELECTED_YEAR, { selectedYear });

export const setGrowthYears = (growthYears: number) =>
  createAction(SET_GROWTH_YEARS, { growthYears });

export const setYearHeadcount = (payload: ManualGrowthEntryUpdate) =>
  createAction(SET_YEAR_HEADCOUNT, payload);

export const setHeadcountSeatCountGrowthRate = (
  headcountSeatCountGrowthRate?: number
) =>
  createAction(SET_HEADCOUNT_SEAT_COUNT_GROWTH_RATE, {
    headcountSeatCountGrowthRate,
  });

export const setHeadcountSeatCountBase = (headcountSeatCountBase: number) =>
  createAction(SET_HEADCOUNT_SEAT_COUNT_BASE, {
    headcountSeatCountBase,
  });

export const updateBuildingScenarios = (scenarios: PlainProgramScenario[]) =>
  createAction(UPDATE_BUILDING_SCENARIOS, { scenarios });

export const setCalculatorType = (calculatorType: null | CalculatorType) =>
  createAction(SET_CALCULATOR_TYPE, { calculatorType });

export const setScenarioDialogStatus = (
  status: boolean,
  duplicated = false,
  step?: string | null
) => createAction(SET_SCENARIO_DIALOG_STATUS, { status, duplicated, step });

export const setUpdateScenarioDialog = (isUpdate = false) =>
  createAction(SET_UPDATE_SCENARIO_DIALOG, { isUpdate });

export const setWorksheetUpdateDialogStatus = (status: boolean) =>
  createAction(SET_WORKSHEET_UPDATE_DIALOG_STATUS, { status });

export const setWorksheetNotesDialogStatus = (status: boolean) =>
  createAction(SET_WORKSHEET_NOTES_DIALOG_STATUS, { status });

export const setTotalProgramDialogStatus = (
  status: boolean,
  isUpdate = false
) => createAction(SET_TOTAL_PROGRAM_DIALOG_STATUS, { status, isUpdate });

export const prepareScenarioForUpdate = () =>
  createAction(PREPARE_SCENARIO_FOR_UPDATE);

export const updateScenario = (
  scenario: PlainProgramScenario,
  changes: Partial<Scenario>
) => createAction(UPDATE_SCENARIO, { scenario, changes });

export const saveScenario = (options: {
  scenarioName: string;
  scenarioNote: string;
  shouldCopyNotes: boolean;
  floorId?: number;
  departmentId?: number;
  isDetailed: boolean;
  isShared: boolean;
  redirect?: (scenario: PlainProgramScenario) => void;
}) => createAction(SAVE_SCENARIO, options);

export const saveScenarioSuccess = () => createAction(SAVE_SCENARIO_SUCCESS);
export const saveScenarioFailed = () => createAction(SAVE_SCENARIO_FAILED);

export const setFactor = (factor: string, value: number) =>
  createAction(SET_FACTOR, { factor, value });

export const getProjectScenarios = (projectId?: number) =>
  createAction(GET_PROJECT_SCENARIOS, {
    projectId,
  });

export const getScenariosSuccess = (scenarios: PlainProgramScenario[]) =>
  createAction(GET_SCENARIOS_SUCCESS, { scenarios });
export const getScenariosFailed = () => createAction(GET_SCENARIOS_FAILED);

export const getScenario = (scenarioId: number) =>
  createAction(GET_SCENARIO, { scenarioId });

export const getTotalProgram = (totalProgramId: number) =>
  createAction(GET_TOTAL_PROGRAM, { totalProgramId });

export const setLoadingScenarios = (flag: boolean) =>
  createAction(SET_LOADING_SCENARIOS, { flag });

export const setCurrentScenario = (
  inputScenario: Scenario | PlainProgramScenario | ITotalProgram,
  associatedScenarios?: Scenario[] | PlainProgramScenario[]
) => {
  const scenario = isProgramScenario(inputScenario)
    ? inputScenario
    : ProgramScenarioFactory.create(
        inputScenario,
        associatedScenarios
      )?.toPlainObject();
  return createAction(SET_CURRENT_SCENARIO, { scenario });
};

export const fetchTpsWorksheets = () => createAction(FETCH_TPS_WORKSHEETS);

export const fetchTpsWorksheetsSuccess = (worksheets: PlainWorksheet[]) =>
  createAction(FETCH_TPS_WORKSHEETS_SUCCESS, {
    worksheets,
  });

export const fetchProjectWorksheets = (scenarioIds?: number[]) =>
  createAction(FETCH_PROJECT_WORKSHEETS, { scenarioIds });

export const fetchProjectWorksheetsSuccess = (worksheets: PlainWorksheet[]) =>
  createAction(FETCH_PROJECT_WORKSHEETS_SUCCESS, {
    worksheets,
  });

export const fetchProjectWorksheetsFailed = () =>
  createAction(FETCH_PROJECT_WORKSHEETS_FAILED);

export const setIsEditingSavedScenario = (value: boolean) =>
  createAction(SET_IS_EDITING_SAVED_SCENARIO, { value });

export const saveScenarioWorkSeatsRoundingSetting = (
  workSeatsRoundingSetting: WorkSeatsRoundingSetting
) =>
  createAction(
    SAVE_SCENARIO_WORK_SEATS_ROUNDING_SETTING,
    workSeatsRoundingSetting
  );

export const saveUpdatingScenario = (
  refresh?: boolean,
  hideUpdate?: boolean,
  sharedSpacesFieldsToKeep?: { [spaceType: string]: IWorksheetRowValue },
  workspacesFieldToKeep?: IWorksheetRowValue,
  onSucess?: () => void
) =>
  createAction(SAVE_UPDATING_SCENARIO, {
    refresh,
    hideUpdate,
    sharedSpacesFieldsToKeep,
    workspacesFieldToKeep,
    onSucess,
  });

export const setSubtotalProgramMultiplier = (value: number) =>
  createAction(SET_SUBTOTAL_PROGRAM_MULTIPLIER, { value });

export const setRsfLoadFactor = (value: number | null) =>
  createAction(SET_RSF_LOAD_FACTOR, { value });

export const setSubtotalBuildingMultiplier = (value: number) =>
  createAction(SET_SUBTOTAL_BUILDING_MULTIPLIER, { value });

export const setPlanningFactor = (value: number) =>
  createAction(SET_PLANNING_FACTOR, { value });

export const setIsUnsavedDialogOpen = (isOpen: boolean) =>
  createAction(SET_IS_UNSAVED_DIALOG_OPEN, { isOpen });

export const setIsCalculatorDirty = (isDirty: boolean) =>
  createAction(SET_IS_CALCULATOR_DIRTY, { isDirty });

export const setTotalProgramAvailableUsf = (value: number) =>
  createAction(SET_TOTAL_PROGRAM_AVAILABLE_USF, {
    value,
  });

export const setScenarioValue = ({
  value,
  factor,
}: {
  value: number | string;
  factor: string;
}) => createAction(SET_SCENARIO_VALUE, { value, factor });

export const setIsLoading = (isLoading: boolean) =>
  createAction(SET_CALCULATOR_LOADING, { isLoading });

export const saveWorksheet = () => createAction(SAVE_WORKSHEET);

export const fetchCurrentWorksheet = () =>
  createAction(FETCH_CURRENT_WORKSHEET);

export const fetchCurrentWorksheetSuccess = () =>
  createAction(FETCH_CURRENT_WORKSHEET_SUCCESS);

export const fetchCurrentWorksheetFailed = () =>
  createAction(FETCH_CURRENT_WORKSHEET_FAILED);

export const populateWorksheet = (worksheet: PlainWorksheet) =>
  createAction(POPULATE_CURRENT_WORKSHEET, { worksheet });

export const setIsDeleteConfirmationOpen = (isOpen: boolean) =>
  createAction(SET_IS_DELETE_CONFIRMATION_OPEN, { isOpen });

export const deleteScenario = (
  redirect?: (scenario: Scenario | PlainProgramScenario | ITotalProgram) => void
) => createAction(DELETE_SCENARIO, { redirect });

export const setTemporaryScenario = (scenario: PlainProgramScenario) =>
  createAction(SET_TEMPORARY_SCENARIO, { scenario });

export const postWorksheetRow = (
  row: IWorksheetRow,
  worksheetId: number,
  isNew?: boolean,
  unitsHigh?: number,
  name?: string
) =>
  createAction(POST_WORKSHEET_ROW, {
    row,
    worksheetId,
    isNew,
    unitsHigh,
    name,
  });

export const createWorksheetNote = (note: ICategoryNote, worksheetId: number) =>
  createAction(CREATE_WORKSHEET_NOTE, { note, worksheetId });

export const bulkUpdateScenarios = (scenarios: Scenario[]) =>
  createAction(BULK_UPDATE_SCENARIO, { scenarios });

export const updateDepartmentScenarios = (rsfLoadFactor: number) =>
  createAction(UPDATE_DEPARTMENT_SCENARIOS, { rsfLoadFactor });

export const createTotalProgram = (
  totalProgram: Partial<ITotalProgram>,
  {
    scenarioIdsToLink,
    redirect,
  }: {
    scenarioIdsToLink: number[];
    redirect?: () => void;
  }
) =>
  createAction(CREATE_TOTAL_PROGRAM, {
    totalProgram,
    scenarioIdsToLink,
    redirect,
  });

export const updateTotalProgram = (
  totalProgram: Partial<ITotalProgram>,
  { scenarioIdsToLink }: { scenarioIdsToLink: number[] }
) => createAction(UPDATE_TOTAL_PROGRAM, { totalProgram, scenarioIdsToLink });

export const createTotalProgramSuccess = (
  totalProgram: Partial<ITotalProgram>,
  totalProgramEnhanced: PlainProgramScenario
) =>
  createAction(CREATE_TOTAL_PROGRAM_SUCCESS, {
    totalProgram,
    totalProgramEnhanced,
  });

export const totalProgramScenariosFetchSuccess = (
  totalPrograms?: PlainProgramScenario[]
) =>
  createAction(TOTAL_PROGRAM_SCENARIOS_FETCH_SUCCESS, {
    totalPrograms,
  });

export const totalProgramScenariosFetchFailed = () =>
  createAction(TOTAL_PROGRAM_SCENARIOS_FETCH_FAILED);
export const rebuildTotalProgramScenarioView = () =>
  createAction(REBUILD_TOTAL_PROGRAM_SCENARIO_VIEW);

export const bulkUpdateTotalPrograms = (totalPrograms: ITotalProgram[]) =>
  createAction(BULK_UPDATE_TOTAL_PROGRAM, { totalPrograms });

export const createTotalProgramNote = (
  note: ICategoryNote,
  totalProgramId: number
) => createAction(CREATE_TOTAL_PROGRAM_NOTE, { note, totalProgramId });

export const updateChildWorksheetSpaceType = (
  childWorksheetSpaceType: Partial<IChildWorksheetSpaceType>,
  unitsHigh: number
) =>
  createAction(UPDATE_CHILD_WORKSHEET_SPACE_TYPE, {
    childWorksheetSpaceType,
    unitsHigh,
  });

export const createChildWorksheetSpaceSuccess = (
  childWorksheetSpace: Partial<IChildWorksheetSpaceType>
) =>
  createAction(CREATE_CHILD_WORKSHEET_SPACE_SUCCESS, { childWorksheetSpace });

export const fetchAllChildWorksheetSpacesSuccess = (
  childWorksheetSpaces: IChildWorksheetSpaceType[]
) =>
  createAction(FETCH_ALL_CHILD_WORKSHEET_SPACES_SUCCESS, childWorksheetSpaces);

export const fetchAllChildWorksheetSpaces = () =>
  createAction(FETCH_ALL_CHILD_WORKSHEET_SPACES);

export const setChildWorksheetSpacesRequestStatus = (status: REQUEST_STATUS) =>
  createAction(SET_CHILD_WORKSHEET_SPACES_REQUEST_STATUS, { status });

export const updateLinkedScenarios = (
  totalProgram: ITotalProgram,
  changes: Partial<Scenario>
) => createAction(UPDATE_LINKED_SCENARIOS, { totalProgram, changes });

export const populateWorksheetFromRequest = (
  worksheet: IWorksheetAPIObject | IWorksheet
) => createAction(POPULATE_WORKSHEET_FROM_REQUEST, { worksheet });

export const isSpaceTypeDeletable = (spaceTypeId: number, isChild: boolean) =>
  createAction(IS_SPACE_TYPE_DELETABLE, { spaceTypeId, isChild });

export const setIsSpaceTypeDeletable = (canDeleteSpaceType: boolean) =>
  createAction(SET_IS_SPACE_TYPE_DELETABLE, { canDeleteSpaceType });

export const exportReport = (reportRequest: ReportEntry[], zipName: string) =>
  createAction(EXPORT_REPORT, { reportRequest, zipName });

export const cloneScenario = (options: {
  scenarioId: number;
  name: string;
  isDetailed: boolean;
  isShared: boolean;
  shouldCopyNotes: boolean;
  optionsForCopy?: {
    scenarioFloorId?: number;
    scenarioDepartmentId?: number;
  };
  optionsForCopyWithDifferentCalculator?: {
    calculatorType?: CalculatorType;
    department?: IDepartment;
    floor?: IFloor;
    selectedFloorUSF?: number;
    selectedBuildingUSF?: number;
  };
  redirect?: (scenario: Scenario) => void;
}) => createAction(CLONE_SCENARIO, options);

export const buildTotalPrograms = () => createAction(BUILD_TOTAL_PROGRAMS);

export const setScenarioListType = (scenarioListType: string) =>
  createAction(SET_SCENARIO_LIST_TYPE, { scenarioListType });

export const actions = {
  setSelectedYear,
  setGrowthYears,
  setYearHeadcount,
  setHeadcountSeatCountGrowthRate,
  setHeadcountSeatCountBase,
  buildNewScenario,
  buildNewScenarioSuccess,
  setCalculatorType,
  updateScenario,
  setScenarioDialogStatus,
  setUpdateScenarioDialog,
  setWorksheetUpdateDialogStatus,
  setWorksheetNotesDialogStatus,
  setTotalProgramDialogStatus,
  saveScenario,
  saveScenarioSuccess,
  saveScenarioFailed,
  setFactor,
  getProjectScenarios,
  setLoadingScenarios,
  getScenariosSuccess,
  getScenariosFailed,
  getScenario,
  updateBuildingScenarios,
  setCurrentScenario,
  setIsEditingSavedScenario,
  saveUpdatingScenario,
  setSubtotalProgramMultiplier,
  setRsfLoadFactor,
  setSubtotalBuildingMultiplier,
  setPlanningFactor,
  setScenarioValue,
  setScenarioListType,
  setIsLoading,
  saveWorksheet,
  fetchCurrentWorksheet,
  fetchCurrentWorksheetSuccess,
  fetchCurrentWorksheetFailed,
  populateWorksheet,
  setIsDeleteConfirmationOpen,
  deleteScenario,
  setTemporaryScenario,
  postWorksheetRow,
  bulkUpdateScenarios,
  updateDepartmentScenarios,
  createWorksheetNote,
  createTotalProgram,
  createTotalProgramSuccess,
  updateTotalProgram,
  getTotalProgram,
  totalProgramScenariosFetchSuccess,
  totalProgramScenariosFetchFailed,
  setChildWorksheetSpacesRequestStatus,
  fetchTpsWorksheets,
  fetchTpsWorksheetsSuccess,
  fetchProjectWorksheets,
  fetchProjectWorksheetsSuccess,
  fetchProjectWorksheetsFailed,
  rebuildTotalProgramScenarioView,
  bulkUpdateTotalPrograms,
  createTotalProgramNote,
  updateChildWorksheetSpaceType,
  createChildWorksheetSpaceSuccess,
  fetchAllChildWorksheetSpacesSuccess,
  fetchAllChildWorksheetSpaces,
  setTotalProgramAvailableUsf,
  updateLinkedScenarios,
  setIsCalculatorDirty,
  setIsUnsavedDialogOpen,
  populateWorksheetFromRequest,
  isSpaceTypeDeletable,
  setIsSpaceTypeDeletable,
  exportReport,
  cloneScenario,
  buildTotalPrograms,
  saveScenarioWorkSeatsRoundingSetting,
};

export type Actions = ActionsUnion<typeof actions>;
